<template>
  <div>
    <div style="position: fixed; top: 10px; z-index: 9000; right: 95px">
      <Filtro @exportar="exportar" :filtro="false">

      </Filtro>
    </div>
    <div class="card card-modern" style="padding: 0; overflow: hidden; border: 1px solid #e2e8f0; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
      <div style="display: flex; background-color: #f8fafc; font-weight: 600; color: #64748b; border-bottom: 1px solid #e2e8f0;">
      <div
        style="
          width: 33.33333%;
          border-right: 1px solid #e2e8f0;
          display: inline-flex;
        "
      >
        <div
          style="
            display: inline-block;
            width: calc(100% - 120px);
            border-right: 1px solid #e2e8f0;
            padding: 5px;
            text-align: center;
          "
        >
          Ponto de Vista Fundamental (PVF)
        </div>
        <div
          style="
            display: inline-block;
            width: 60px;
            border-right: 1px solid #e2e8f0;
            padding: 5px;
            text-align: center;
          "
        >
          Valor
        </div>
        <div
          style="
            display: inline-block;
            width: 60px;
            padding: 5px 0px 5px 0px;
            text-align: center;
          "
        >
          Peso (%)
        </div>
      </div>
      <div
        style="width: 33.33333%; border-right: 1px solid #e2e8f0; display: flex"
      >
        <div
          style="
            display: inline-block;
            width: calc(100% - 120px);
            border-right: 1px solid #e2e8f0;
            padding: 5px;
            text-align: center;
          "
        >
          Fator Crítico de Sucesso (FCS)
        </div>
        <div
          style="
            display: inline-block;
            width: 60px;
            border-right: 1px solid #e2e8f0;
            padding: 5px;
            text-align: center;
          "
        >
          Valor
        </div>
        <div
          style="
            display: inline-block;
            width: 60px;
            padding: 5px 0px 5px 0px;
            text-align: center;
          "
        >
          Peso (%)
        </div>
      </div>
      <div style="width: 33.33333%; display: flex">
        <div
          style="
            display: inline-block;
            width: calc(100% - 120px);
            border-right: 1px solid #e2e8f0;
            padding: 5px;
            text-align: center;
          "
        >
          Key Performance Indicator (KPI)
        </div>
        <div
          style="
            display: inline-block;
            width: 60px;
            border-right: 1px solid #e2e8f0;
            padding: 5px;
            text-align: center;
          "
        >
          Valor
        </div>
        <div
          style="
            display: inline-block;
            width: 60px;
            padding: 5px 0px 5px 0px;
            text-align: center;
          "
        >
          Peso (%)
        </div>
      </div>
    </div>

    <div class="kpi-row">
      <div class="kpi-col" style="width: 100%; border: 1px solid #e2e8f0">
        <div v-for="(f, i) in kpi" :key="i" class="kpi-row linha">
          <div style="width: 33.33%; display: flex">
            <span class="kpi-texto">{{ f.nome }}</span>
            <div class="kpi-valor">
              <span class="kpi-texto-centro">{{
                parseFloat(f.valor).toFixed(2).replace(".", ",")
              }}</span>
            </div>
            <div class="kpi-valor">
              <span class="kpi-texto-centro"
                >{{ (f.indice * 100).toFixed(2).replace(".", ",") }}%</span
              >
            </div>
          </div>
          <div
            class="kpi-col"
            style="
              min-width: 66.33%;
              margin-bottom: -1px;
              border-left: 1px solid #e2e8f0;
            "
          >
            <div v-for="(c, ci) in f.fcss" :key="ci" class="kpi-row linha">
              <div style="width: 50%; display: flex">
                <span class="kpi-texto">{{ c.nome }}</span>
                <div class="kpi-valor">
                  <span class="kpi-texto-centro">{{
                    parseFloat(c.valor).toFixed(2).replace(".", ",")
                  }}</span>
                </div>
                <div class="kpi-valor" style="border-right: 1px solid #e2e8f0">
                  <span class="kpi-texto-centro"
                    >{{ (c.indice * 100).toFixed(2).replace(".", ",") }}%</span
                  >
                </div>
              </div>
              <div class="kpi-col" style="min-width: 50%">
                <div
                  v-for="(k, ki) in c.kpis"
                  :key="ki"
                  class="kpi-row"
                  style="height: 100%"
                >
                  <span class="kpi-texto">{{ k.nome }}</span>
                  <div class="kpi-valor">
                    <span class="kpi-texto-centro">{{
                      parseFloat(k.valor).toFixed(2).replace(".", ",")
                    }}</span>
                  </div>
                  <div class="kpi-valor">
                    <span class="kpi-texto-centro"
                      >{{
                        (k.indice * 100).toFixed(2).replace(".", ",")
                      }}%</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Filtro from "../Filtro.vue";
export default {
  components: {
    Filtro,
  },
  props: ["kpiinit"],
  data() {
    return {
      kpi: this.kpiinit,
    };
  },
  methods: {
    exportar() {
      var json = [];
      json.push({
        1: "Ponto de Vista Fundamental (PVF)",
        2: "Valor",
        3: "Peso (%)",
        4: "Fator Crítico de Sucesso (FCS)",
        5: "Valor ",
        6: "Peso (%) ",
        7: "Key Performance Indicator (KPI)",
        8: "Valor  ",
        9: "Peso (%)  ",
      });
      for (const p of this.kpi) {
        for (const f of p.fcss) {
          for (const k of f.kpis) {
            json.push({
              1: p.nome,
              2: parseFloat(p.valor).toFixed(2).replace(".", ","),
              3: (p.indice * 100).toFixed(2).replace(".", ",") + "%",
              4: f.nome,
              5: parseFloat(f.valor).toFixed(2).replace(".", ","),
              6: (f.indice * 100).toFixed(2).replace(".", ",") + "%",
              7: k.nome,
              8: parseFloat(k.valor).toFixed(2).replace(".", ","),
              9: (k.indice * 100).toFixed(2).replace(".", ",") + '%',
            });
          }
        }
      }
      PLANILHA.export("KPI", "xlsx", json);
    },
  },
  created() {

  },
};
</script>